import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Image,
  Dropdown,
  DropdownButton,
} from "react-bootstrap";
import { IoImageOutline } from "react-icons/io5";
import englishFlag from "../img/united-kingdom.png";
import chineseFlag from "../img/china.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import axios from "axios";

function AddQuestions() {
  const location = useLocation();
  const { assessmentId, assessmentName } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState("Select tags");
  const [tags, setTags] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [languageState, setLanguageState] = useState({
    language: "English",
    flag: englishFlag,
  });

  const addQuestion = {
    width: "100%",
    backgroundColor: "#263F86",
    color: "#ffffff",
    fontFamily: "Manrope-Regular",
  };

  const translations = {
    English: {
      addQuestion: "Add Questions",
      questionPlaceholder: "Enter your question here",
      optionPlaceholder: "Option",
      insertImage: "Insert Image",
      answer: "Answer",
      rightFeedback: "Right Feedback",
      wrongFeedback: "Wrong Feedback",
      saveQuestion: "Save Question",
      answerTitle: "Answer",
      feedback: "Feedback",
      addOption: "Add Option",
      removeOption: "Remove",
    },
    Chinese: {
      addQuestion: "添加问题",
      questionPlaceholder: "在这里输入您的问题",
      optionPlaceholder: "选项",
      insertImage: "插入图片",
      answer: "答案",
      rightFeedback: "正确反馈",
      wrongFeedback: "错误反馈",
      saveQuestion: "保存问题",
      answerTitle: "回答",
      feedback: "反馈",
      addOption: "添加选项",
      removeOption: "删除",
    },
  };

  const [formData, setFormData] = useState({
    question_text: "",
    right_feedback: "That's Correct.",
    wrong_feedback: "Sorry! Try again.",
    user_id: "1",
    tags_id: "",
    type_id: "1",
    selected_language: "English",
    options: [
      { answer_text: "", is_correct: false, score: 0 },
      { answer_text: "", is_correct: false, score: 0 },
    ],
  });

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API + `/getTags`
        );
        if (response.data.success) {
          setTags(response.data.data);
        } else {
          console.error("Error fetching tags:", response.data.message);
        }
      } catch (err) {
        console.error("Failed to fetch tags:", err);
      }
    };

    fetchTags();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("option")) {
      const index = parseInt(name.replace("option", "")) - 1;
      const updatedOptions = [...formData.options];
      updatedOptions[index].answer_text = value;
      setFormData({ ...formData, options: updatedOptions });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleCheckboxChange = (index) => {
    const updatedOptions = formData.options.map((option, i) => ({
      ...option,
      is_correct: i === index ? !option.is_correct : option.is_correct,
      score: i === index ? (!option.is_correct ? 1 : 0) : option.score,
    }));
    setFormData({ ...formData, options: updatedOptions });
  };

  const handleAddOption = () => {
    const newOption = { answer_text: "", is_correct: false, score: 0 };
    setFormData({ ...formData, options: [...formData.options, newOption] });
  };

  const handleRemoveOption = (index) => {
    const updatedOptions = formData.options.filter((_, i) => i !== index);
    setFormData({ ...formData, options: updatedOptions });
  };

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const handleLanguageSelect = (eventKey) => {
    let updatedFlag = englishFlag;

    if (eventKey === "Chinese") {
      updatedFlag = chineseFlag;
    }

    setLanguageState({
      language: eventKey,
      flag: updatedFlag,
    });

    setFormData({ ...formData, selected_language: eventKey });
  };

  const handleSelectTag = (eventKey) => {
    const selectedTag = tags.find(
      (tag) => String(tag.tags_id) === String(eventKey)
    );

    setSelectedValue(selectedTag?.tags_name || "gg");
    setFormData({ ...formData, tags_id: eventKey });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
  
    setIsSubmitting(true);
  
    try {
      if (!formData.question_text || !formData.tags_id) {
        toast.error("Please fill all required fields.", { position: "top-right" });
        setIsSubmitting(false);
        return;
      }
  
      const formDataWithAssessmentId = {
        ...formData,
        assessment_id: assessmentId,
      };
  
      // console.log("Submitting question data:", formDataWithAssessmentId);
  
      const questionUrl = `${process.env.REACT_APP_API}/insertQuestion`;
      const questionResponse = await axios.post(questionUrl, formDataWithAssessmentId);
  
      // console.log("Question response:", questionResponse.data);
  
      if (questionResponse.data.success) {
        const question_id = questionResponse.data.question_id;
  
        const payload = {
          question_id,
          answers: formData.options,
        };
  
        // console.log("Submitting answer data:", payload);
  
        const answerUrl = `${process.env.REACT_APP_API}/insertAnswers`;
        const answerResponse = await axios.post(answerUrl, payload, {
          timeout: 10000, // Timeout after 10 seconds
        });
  
        // console.log("Answer response:", answerResponse.data);
  
        if (answerResponse.data.success) {
          toast.success("Question and answers saved successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
  
          setFormData((prevData) => ({
            ...prevData,
            question_text: "",
            right_feedback: "That's Correct.",
            wrong_feedback: "Sorry! Try again.",
            options: [
              { answer_text: "", is_correct: false, score: 0 },
              { answer_text: "", is_correct: false, score: 0 },
            ],
          }));
        } else {
          throw new Error(answerResponse.data.message || "Failed to save answers.");
        }
      } else {
        throw new Error(questionResponse.data.message || "Failed to save question.");
      }
    } catch (err) {
      // console.error("Error during form submission:", err.response || err);
      toast.error(err.response?.data?.message || "Something went wrong!", {
        position: "top-right",
        autoClose: 1000,
      });
    } finally {
      setIsSubmitting(false);
      // console.log("Submission process completed.");
    }
  };
  
  
  const currentLanguage = translations[languageState.language];

  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        style={addQuestion}
        onClick={handleOpenModal}
      >
        Add Questions
      </button>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        style={{ fontFamily: "Manrope-Regular" }}
      >
        <form onSubmit={handleSubmit}>
          {" "}
          {/* Keep only this <form> */}
          <Modal.Header closeButton>
            <div className="d-flex w-100 justify-content-between align-items-center">
              <Modal.Title style={{ color: "#263F86" }}>
                {assessmentName || "Module Questions"}
              </Modal.Title>
              <div className="d-flex align-items-center me-auto ms-4">
                <p className="mb-0 me-2">{languageState.language}</p>
                <Image
                  src={languageState.flag}
                  width="30"
                  alt="Language"
                  roundedCircle
                />
                <DropdownButton
                  title={languageState.language || "Select Language"}
                  onSelect={handleLanguageSelect}
                  variant="outline-secondary"
                  className="mx-2"
                >
                  <Dropdown.Item eventKey="English">English</Dropdown.Item>
                  <Dropdown.Item eventKey="Chinese">Chinese</Dropdown.Item>
                </DropdownButton>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            {/* Remove the nested <form> */}
            <div className="row p-2">
              <div className="col-md-9">
                <textarea
                  className="form-control"
                  name="question_text"
                  value={formData.question_text}
                  onChange={handleChange}
                  rows="3"
                  placeholder={currentLanguage.questionPlaceholder}
                ></textarea>
              </div>
              <div className="col-md-3">
                <button
                  type="button"
                  className="btn w-75 fw-semibold preview"
                  style={{
                    borderColor: "#263F86",
                    color: "#263F86",
                  }}
                >
                  {currentLanguage.insertImage}
                </button>
                <DropdownButton
                  title={selectedValue || "Select tags"}
                  onSelect={handleSelectTag}
                  variant="outline-secondary"
                  className="mt-3"
                >
                  {Array.isArray(tags) && tags.length > 0 ? (
                    tags.map((tag) => (
                      <Dropdown.Item key={tag.tags_id} eventKey={tag.tags_id}>
                        {tag.tags_name}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item disabled>No tags available</Dropdown.Item>
                  )}
                </DropdownButton>
                {selectedValue === undefined ||
                selectedValue === "Select tags" ? (
                  <p style={{ fontSize: "12px", color: "red" }}>
                    *Please select tags
                  </p>
                ) : null}
              </div>
            </div>
            <h5 className="fw-bold" style={{ color: "#263F86" }}>
              {currentLanguage.answerTitle}
            </h5>
            {formData.options.map((option, index) => (
              <div className="container mb-3" key={index}>
                <div className="row align-items-center">
                  <div className="col-auto">
                    <Form.Check
                      type="checkbox"
                      label=""
                      className="custom-checkbox"
                      checked={option.is_correct}
                      onChange={() => handleCheckboxChange(index)}
                    />
                  </div>
                  <div className="col">
                    <Form.Control
                      type="text"
                      placeholder={`${currentLanguage.optionPlaceholder} #${
                        index + 1
                      }`}
                      name={`option${index + 1}`}
                      value={option.answer_text}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-auto">
                    <Button variant="outline-secondary">
                      <IoImageOutline
                        size={"20"}
                        style={{ marginRight: "3px" }}
                      />
                    </Button>
                  </div>
                  <div className="col-auto">
                    <Button
                      variant="danger"
                      onClick={() => handleRemoveOption(index)}
                    >
                      {currentLanguage.removeOption}
                    </Button>
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-primary mt-3"
              style={{
                backgroundColor: "#263F86",
                color: "#ffffff",
                fontFamily: "Manrope-Regular",
              }}
              onClick={handleAddOption}
            >
              + {currentLanguage.addOption}
            </button>
            <h5 className="mt-3 mb-3 fw-bold" style={{ color: "#263F86" }}>
              {currentLanguage.feedback}
            </h5>
            <div className="row">
              <div className="col">
                <p>{currentLanguage.rightFeedback}</p>
                <textarea
                  className="form-control"
                  name="right_feedback"
                  value={formData.right_feedback}
                  onChange={handleChange}
                  rows="3"
                ></textarea>
              </div>

              <div className="col">
                <p>{currentLanguage.wrongFeedback}</p>
                <textarea
                  className="form-control"
                  name="wrong_feedback"
                  value={formData.wrong_feedback}
                  onChange={handleChange}
                  rows="3"
                ></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="submit"
              className="btn btn-primary"
              style={{
                backgroundColor: "#263F86",
                color: "#ffffff",
                fontFamily: "Manrope-Regular",
              }}
            >
              {currentLanguage.saveQuestion}
            </button>
          </Modal.Footer>
        </form>
      </Modal>

      <ToastContainer />
    </>
  );
}

export default AddQuestions;
